import { Component, OnInit, Inject,  OnDestroy, ViewChild } from '@angular/core';
import { MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Hotel } from '../../../models/hotels/Hotel';
import { StaticMediaResult } from '../../../models/static/StaticMediaResult';
import { TvangebotimagevideoComponent } from '../../modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TVAngebot } from '../../../models/sktv/TVAngebot';
import { AuthGuardService } from '../../../services/auth-guard.service';
import { TrafficsService } from '../../../services/traffics.service';
import { NavigationExtras, Router } from '@angular/router';
import { ParamFilters } from '../../../models/filtermodels/ParamFilters';
import { EncryptionService } from '../../../services/encyption.service';
import { MapcomponentComponent } from '../mapcomponent/mapcomponent.component';
import { HotelreviewComponent } from '../hotelreview/hotelreview.component';
import { HotelsFilters } from 'src/app/models/filtermodels/HotelsFilters';
import moment from 'moment';

interface DialogData {
    hotel: Hotel;
    sktvContent?: any;
    desktopTemplate: string;
    alternatives: boolean;
    tourOperator: string;
}

interface TourModel {
    code: string;
    name: string;
    logo: string;
    catalogName: string;
}

@Component({
    selector: 'app-hotelinfo',
    templateUrl: './hotelinfo.component.html',
    styleUrls: ['./hotelinfo.component.scss'],
    standalone: false
})
export class HotelinfoComponent implements OnInit, OnDestroy {
    private subscribes: Subscription[] = [];
    @ViewChild('hotelinfo') hotelinfo: any;
    html: string;
    title: string = '';
    selectedtourcode: string = '';
    currenttourcode: TourModel;
    desktopTemplate: string = 'lg';
    hotel: Hotel;
    categoryAr = [];
    images = [];
    loading: boolean = true;
    hts: StaticMediaResult;
    partner: any;
    sktvContent: TVAngebot;
    catalogfootertext: string = '';
    alternativeCatalogList: TourModel[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DialogData,
        private dialog: MatDialog,
        private router: Router,
        private encservice: EncryptionService,
        private guardService: AuthGuardService,
        private trafficsService: TrafficsService
    ) { }

    ngOnInit(): void {
        this.initData();
    }

    
    ngOnDestroy(): void {
        this.subscribes.forEach(element => {
            element.unsubscribe();
        });
    }

    async initData() {
        this.title = this.data?.hotel?.name;
        this.desktopTemplate = this.data.desktopTemplate;
        this.sktvContent = this.data?.sktvContent;
        if (this.data?.hotel) {
            this.hotel = JSON.parse(JSON.stringify(this.data?.hotel));
            if (this.hotel?.giata?.hotelId?.length > 0) {
                this.getReview(this.data?.hotel?.giata?.hotelId);
                this.getKeywords(this.data?.hotel?.giata?.hotelId);
                this.getGiata(this.data?.hotel?.giata?.hotelId);
            }
            this.images = this.hotel?.catalogData?.imageList;
            const catg = Number(String(this.hotel?.category).replace(/,/g, '.').replace(/\+/g, ''));
            for (let i = 0; i < Math.floor(catg); i++) {
                this.categoryAr.push(1);
            }
            if (catg > Math.floor(catg)) {
                this.categoryAr.push(0.5);
            }
        }
        this.getHotelInfos();
    }

    async getHotelInfos() {
        this.subscribes.push(this.guardService.getPartner$.subscribe(res => {
            this.partner = res;
            this.loading = false;
            if (this.hotel?.catalogData) {
                this.catalogfootertext = '';
                this.catalogfootertext += this.hotel?.catalogData?.tourOperator?.name?.length > 0 ? '' + this.hotel.catalogData.tourOperator.name : '';
                this.catalogfootertext += this.hotel?.catalogData?.tourOperator?.code?.length > 0 ? ' (' + this.hotel.catalogData.tourOperator.code + ')' : '';
                this.catalogfootertext += this.hotel?.catalogData?.catalogName?.length > 0 ? ', Katalog: ' + this.hotel.catalogData.catalogName : '';
                this.html = this.data?.hotel?.catalogData?.html;
                if (this.data?.alternatives && this.data?.hotel?.catalogData?.alternativeCatalogList?.length > 0) {
                    for (let i = 0; i < this.data.hotel.catalogData.alternativeCatalogList.length; i++) {
                        const element = this.data.hotel.catalogData.alternativeCatalogList[i];
                        let found = false;
                        let isactivepartneragentur = false;
                        if (this.partner?.agenturen?.length > 0) {
                            for (let k = 0; k < this.partner.agenturen.length; k++) {
                                if (this.partner.agenturen[k].code === element.tourOperator.code) {
                                    isactivepartneragentur = this.partner.agenturen[k].aktiv;
                                    k = this.partner.agenturen.length;
                                }
                            }
                        }
                        if (this.alternativeCatalogList.length > 0) {
                            for (let j = 0; j < this.alternativeCatalogList.length; j++) {
                                if (this.alternativeCatalogList[j].code === element.tourOperator.code) {
                                    found = true;
                                    j = this.alternativeCatalogList.length;
                                }
                            }
                        }
                        if (!found && isactivepartneragentur) {
                            this.alternativeCatalogList.push(
                                {
                                    code: element.tourOperator.code,
                                    name: element.tourOperator.name,
                                    logo: element.tourOperator.logo,
                                    catalogName: element.catalogName
                                }
                            );
                        }
                    }
                    if (this.data.tourOperator?.length > 0) {
                        if (this.data.tourOperator === 'SLRD') {
                            this.data.tourOperator = 'SLR';
                        }
                        this.selectedtourcode = this.data.tourOperator;
                        for (let i = 0; i < this.alternativeCatalogList.length; i++) {
                            if (this.alternativeCatalogList[i]?.code === this.data.tourOperator) {
                                this.currenttourcode = this.alternativeCatalogList[i];
                                i = this.alternativeCatalogList.length;
                            }
                        }
                        this.getHotelInfoDatas();
                    } else {
                        this.selectedtourcode = this.alternativeCatalogList[0]?.code;
                        this.currenttourcode = this.alternativeCatalogList[0];
                    }
                }
            }
        }));
    }

    async getCatalogDataFromGiata(ev) {
        for (let i = 0; i < this.alternativeCatalogList.length; i++) {
            if (this.alternativeCatalogList[i]?.code === ev?.value) {
                this.currenttourcode = this.alternativeCatalogList[i];
                i = this.alternativeCatalogList.length;
            }
        }
        this.getHotelInfoDatas();
    }

    async getHotelInfoDatas() {
        if (this.data?.hotel?.giata?.hotelId?.length > 0 && this.currenttourcode?.code?.length > 0) {
            this.loading = true;
            this.subscribes.push(this.trafficsService.request({ giataId: this.data.hotel.giata.hotelId, tourOperatorList: this.currenttourcode?.code }, 'hotels/giataId').subscribe((res) => {
                if (!res.error) {
                    if (res?.hotel?.catalogData?.html?.length > 0) {
                        this.initBilders(res);
                        this.catalogfootertext = '';
                        this.catalogfootertext += res?.hotel?.catalogData?.tourOperator?.name?.length > 0 ? '' + res?.hotel.catalogData.tourOperator.name : '';
                        this.catalogfootertext += res?.hotel?.catalogData?.tourOperator?.code?.length > 0 ? ' (' + res?.hotel.catalogData.tourOperator.code + ')' : '';
                        this.catalogfootertext += res?.hotel?.catalogData?.catalogName?.length > 0 ? ', Katalog: ' + res?.hotel.catalogData.catalogName : '';
                    } else {
                        this.html = '<strong class="strong">Information aktuell nicht verfügbar</strong>';
                        this.catalogfootertext = '';
                    }
                }
                this.loading = false;
            }));
        }
    }

    async getGiata(giataId) {
        this.subscribes.push(this.trafficsService.request({ giataId: giataId }, 'hotels/giataId').subscribe((res) => {
            if (!res.error) {
                this.hotel.address = res?.hotel?.address;
            }
        }));
    }

    async getReview(giataId) {
        this.subscribes.push(this.trafficsService.request({ giataId: giataId, source: 'holidaycheck' }, '/hotels/giataId/reviews').subscribe((res) => {
            if (!res.error) {
                this.hotel.reviews = res;
            }
        }));
    }

    async getKeywords(giataIdList) {
        // default datas
        const filtersData = {} as HotelsFilters;
        filtersData.adults = '2';
        filtersData.giataIdList = giataIdList;
        filtersData.navigation = '1, 2';
        filtersData.productType = 'pauschal';
        filtersData.productSubType = 'all';
        filtersData.searchDate = '10,180,7';
        filtersData.rating = {
            source: 'holidaycheck',
            count: 0,
            recommendation: 0,
            overall: 0,
        };
        this.subscribes.push(this.trafficsService.request(filtersData, 'hotels').subscribe((res) => {
            if (!res?.error) {
                if (res?.hotelList?.length > 0) {
                    this.hotel.rating = res.hotelList[0]?.rating;
                    this.hotel.keywordList = res.hotelList[0]?.keywordList;
                }
            }
            this.loading = false;
        }));
    }

    initBilders(res) {
        if (res?.hotel?.catalogData?.imageList?.length > 0) {
            this.images = res?.hotel?.catalogData?.imageList;
            for (let i = 0; i < this.images?.length; i++) {
                this.images[i] = this.images[i].replace(/http:/g, 'https:');
            }
        } else {
            this.images = [];
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.sktvContent ? this.sktvContent : this.hotel,
                images: this.sktvContent?.images?.length > 0 ? this.sktvContent.images : this.images,
                videos: this.sktvContent?.video?.length > 0 ? this.sktvContent.video : [],
                current: ev,
                to800: !this.sktvContent,
                desktopTemplate: this.desktopTemplate
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
    }

    async goToOffers() {
        if (this.sktvContent) {
            const realparams = {} as ParamFilters;
            const dateFirst = this.sktvContent.depart?.first?.length > 0 ? this.sktvContent.depart.first : '';
            const dateLast = this.sktvContent.depart?.last?.length > 0 ? this.sktvContent.depart.last : '';
            let ddrmin = this.sktvContent?.durationforsearch;
            let ddrmax = ddrmin;
            if (ddrmin === 0) {
                const tmp = this.getDauer(this.sktvContent);
                if (tmp?.length > 0 && !isNaN(Number(tmp)) && Number(tmp) > 2) {
                    ddrmin = Number(tmp) - 2;
                    ddrmax = Number(tmp) + 2;
                } else {
                    ddrmax = 99;
                    ddrmin = 1;
                }
            }

            realparams.reisezeitraumResult = {
                start: moment(dateFirst).format('YYYY-MM-DD'),
                end: moment(dateLast).format('YYYY-MM-DD'),
                minDuration: ddrmin + '',
                maxDuration: ddrmax + '',
            };
            realparams.reisedauerResult = {
                name: ddrmin + '-' + ddrmax + ' Tage',
                minDuration: ddrmin + '',
                maxDuration: ddrmax + '',
            };
            realparams.extra = {
                orderId: this.sktvContent.orderId,
                seller: 'euvia'
            };// this.realparams.extra;

            realparams.reisendeResult = {
                children: [],
                adults: 2,
            };
            realparams.productType = this.sktvContent.producttypeforsearch?.length > 0 ? this.sktvContent.producttypeforsearch : 'pauschal';

            const to_code = this.sktvContent.organizer?.length > 0 ? this.sktvContent.organizer + '_' + this.sktvContent.bookingcode : this.sktvContent.bookingcode;
            realparams.pauschalreiseResult = {
                data: {
                    name: this.sktvContent.name,
                    code: to_code
                },
                type: 1,
            };
            realparams.tourOperatorList = [];
            if(this.sktvContent.organizer?.length > 0) {
                const tmp_ops = this.sktvContent?.organizer?.split(',');
                for (let i = 0; i < tmp_ops?.length; i++) {
                    realparams.tourOperatorList.push( {
                        code: tmp_ops[i],
                        name: ''
                    });
                }
            }
            if(this.sktvContent.hidden_op?.length > 0) {
                realparams.tourOperatorList.push( {
                    code: this.sktvContent.hidden_op,
                    name: ''
                });
            }
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(realparams) }
            };
            // console.log(realparams);
            this.router.navigate([this.guardService.getPartnerId(), 'offers'], navigationExtras);
        }
    }

    getDauer(dd): string {
        let tmp_d = '';
        if (!isNaN(Number(dd?.duration))) {
            tmp_d = dd?.duration;
        } else if (dd?.duration.indexOf('-tägige') >= 0) {
            tmp_d = dd.duration?.slice(0, dd?.duration.indexOf('-tägige')).trim();
        } else if (dd?.duration.indexOf('Nächte') >= 0) {
            tmp_d = dd.duration?.slice(0, dd?.duration.indexOf('Nächte')).trim();
        }
        return tmp_d;
    }

    async openMaps() {
        if (this.hotel?.location?.latitude) {
            let target = {} as MatDialogConfig;
            if (this.desktopTemplate !== 'xs') {
                target = { width: '100%', height: '81vh', panelClass: 'customModal', data: { poi: this.hotel }, autoFocus: false }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { poi: this.hotel }, autoFocus: false }
            }
            this.dialog.open(MapcomponentComponent, target);
        }
    }

    async openReview() {
        if (this.hotel?.reviews) {
            let target = {} as MatDialogConfig;
            if (this.desktopTemplate !== 'xs') {
                target = { height: '81vh', panelClass: 'customModal', data: { reviews: this.hotel?.reviews, title: this.hotel.name }, autoFocus: false }
            } else {
                target = { width: '100%', height: '100%', maxWidth: '100%', panelClass: 'customModal', data: { reviews: this.hotel?.reviews, title: this.hotel.name }, autoFocus: false }
            }
            this.dialog.open(HotelreviewComponent, target);
        }
    }

    handelError(index) {
        if (this.sktvContent?.images?.length > index) {
            this.sktvContent?.images.splice(index, 1);
        }
    }
}
